import { arrayToThresholds } from "./arrayToThresholds";
import { getClosestValue } from "./getClosestValue";

function getFrequencyLabelByValue(value: number) {
  const threshold = getClosestValue(FREQUENCY_THRESHOLDS, value);
  const index = FREQUENCY_THRESHOLDS.indexOf(threshold);
  return FREQUENCY_LABELS[index];
}

function getFrequencyThresholdByValue(value: number) {
  return getClosestValue(FREQUENCY_THRESHOLDS, value);
}

const FREQUENCY_LABELS = [
  "maintenance:priority.select.frequency.slider.0",
  "maintenance:priority.select.frequency.slider.25",
  "maintenance:priority.select.frequency.slider.50",
  "maintenance:priority.select.frequency.slider.75",
  "maintenance:priority.select.frequency.slider.100",
];

const FREQUENCY_THRESHOLDS = arrayToThresholds(FREQUENCY_LABELS);

export function getFrequencyProps() {
  return {
    thresholds: FREQUENCY_THRESHOLDS,
    labels: FREQUENCY_LABELS,
    getFrequencyLabelByValue,
    getFrequencyThresholdByValue,
  };
}
